import { TraceEvents } from '../call-trace-event';
import { find } from 'lodash';
import { byName } from './util';
/**
 * Calculate how long the call took to setup.
 * @param events List of events that have occurred so far.
 * @param finalEventName The event that means the call has started successfully.
 * @returns duration in milliseconds, or undefined on error.
 */
export function selectStartDelay(events, finalEventName) {
    const startEvent = find(events, byName(TraceEvents.Init));
    const endEvent = find(events, byName(finalEventName));
    if (!startEvent || !endEvent) {
        return undefined;
    }
    const delay = endEvent.timestamp - startEvent.timestamp;
    // eslint-disable-next-line consistent-return
    return delay;
}
